import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ClientPassportButton } from "../../../../../components/buttons/ClientPassportButton";
import { IdentificationDocumentsButton } from "../../../../../components/dialog/IdentificationDocumentsDialog";
import { PersonDetailsButton } from "../../../../../components/dialog/PersonDetailsDialog";

export function CustomerActionButton(props) {
    const { customer, size = "small" } = props;

    if (customer.person) {
        return (
            <CustomerPersonActionButton
                customerId={customer.id}
                person={customer.person}
                size={size}
            />
        );
    }
    if (customer.company) {
        return (
            <CustomerCompanyActionButton
                customerId={customer.id}
                company={customer.company}
                size={size}
            />
        );
    }

    return null;
}

const CustomerPersonActionButton = (props) => {
    const { customerId, person, size } = props;

    if (!person.has_basic_info) {
        return (
            <ClientPassportButton
                clientId={customerId}
                clientType="customer"
                size={size}
                color="primary"
            />
        );
    }
    if (!person.has_detailed_info) {
        return <PersonDetailsButton personId={person.id} showLabel={false} variant="contained" />;
    }
    if (!person.has_id_documentation) {
        return (
            <IdentificationDocumentsButton
                personId={person.id}
                showLabel={false}
                variant="contained"
            />
        );
    }
    return <OkButton size={size} />;
};

const CustomerCompanyActionButton = (props) => {
    const { customerId, company, size } = props;

    if (!company.has_basic_info) {
        return (
            <ClientPassportButton
                clientId={customerId}
                clientType="company"
                size={size}
                color="primary"
            />
        );
    }

    return <OkButton size={size} />;
};

const OkButton = ({ size }) => {
    const { t } = useTranslation();
    return (
        <Button variant="outlined" size={size} disabled>
            {t("agreements.AgreementDialogTabs.ok") || "OK"}
        </Button>
    );
};
